module.exports = __webpack_public_path__ + "img/act_pro_img5s_03.f8c751a9.png";